import { render, staticRenderFns } from "./productCen.vue?vue&type=template&id=11163ccf&scoped=true&"
import script from "./productCen.vue?vue&type=script&lang=js&"
export * from "./productCen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11163ccf",
  null
  
)

export default component.exports